import { A1Bescheinigung } from '../../model/a1bescheinigung';
import { GenericValue } from 'hisng';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component( {
    selector: 'erp-businesstripapplication-a1-bescheinigung',
    templateUrl: './businesstripapplication-a1-bescheinigung.component.html'
} )
export class BusinesstripApplicationA1BescheinigungComponent implements OnInit {
    @Input() a1Bescheinigung: A1Bescheinigung = new A1Bescheinigung();
    @Output() readonly a1BescheinigungChange = new EventEmitter<A1Bescheinigung>();

    constructor() { }

    ngOnInit(): void { }

    onModelChange( changedValue: string | GenericValue ): void {
        this.a1BescheinigungChange.emit( this.a1Bescheinigung );
    }
}
